<template>
    <div class="card">
        <div class="card-header">
            {{trans('tasks.cards.header.timers')}}
        </div>
        <div class="card-body" v-loading="loading">
            <table class="table table-sm">
                <thead>
                <tr>
                    <th>Time (hours)</th>
                    <th>Date</th>
                    <th>Comment</th>
                    <th>Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="timer in timersSorted" :key="timer.id">
                    <td>{{timer.duration}}</td>
                    <td>{{renderDate(timer.work_date)}}</td>
                    <td>{{timer.description}}</td>
                    <td>
                        <button type="button" class="btn btn-sm btn-outline-danger" @click="remove(timer)">Remove</button>
                    </td>
                </tr>
                <tr v-for="(trackerForSave, index) in trackersForSave" :key="index">
                    <td>
                        <input class="form-control" type="text" disabled :value="trackerForSave.time">
                    </td>
                    <td>
                        <el-date-picker
                                v-model="trackerForSave.date"
                                type="date"
                                format="dd.MM.yyyy"
                                placeholder="Pick a day"
                                :picker-options="pickerOptions"
                        >
                        </el-date-picker>
                    <td><input class="form-control" type="text" v-model="trackerForSave.comment"></td>
                    <td>
                        <button type="button" class="btn btn-sm btn-secondary" @click="save(trackerForSave)">Save</button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <input class="form-control" type="text" v-model="manually.time">
                    </td>
                    <td>
                        <el-date-picker
                                v-model="manually.date"
                                type="date"
                                format="dd.MM.yyyy"
                                placeholder="Pick a day"
                                :picker-options="pickerOptions">
                        </el-date-picker>
                    </td>
                    <td>
                        <input class="form-control" type="text" v-model="manually.comment">
                    </td>
                    <td>
                        <button type="button" class="btn btn-sm btn-secondary" @click="save(manually)">Save</button>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    let moment = require('moment');
    import _ from 'lodash';

    export default {
        name: "task-timers",
        props: {
            task: Object,
            taskTrackersSync: Array,
        },
        data() {
            return {
                pickerOptions: {
                    firstDayOfWeek: 1,
                },
                timers: [],
                taskTrackers: this.taskTrackersSync,
                listenForTaskTrackers: {},
                loading: false,
                tempData: {},
                trackersForSave: {},
                manually: {
                    time: 0,
                    date: '',
                    comment: ''
                }
            }
        },
        watch: {
            taskTrackersSync: function (newValue) {
                this.taskTrackers = newValue;
            },
            taskTrackers: function (newValue) {
                this.listenForTaskTrackersChanges(newValue);
            },
        },
        computed: {
            timersSorted() {
                return _.sortBy(this.timers, 'work_date');
            }
        },
        mounted() {
            this.loadTimers();
        },
        methods: {
            renderDate(date) {
                return Render.renderDateToFormat(date, 'DD.MM.YYYY');
            },
            actualizeTable(taskTracker, timeIntervals) {
                let vm = this;
                let time = _.sumBy(timeIntervals, function (timeInterval) {
                    let to = null;
                    if (timeInterval.to) {
                        to = moment(timeInterval.to);
                    } else {
                        return 0;
                    }
                    return to.diff(moment(timeInterval.from), 'seconds');
                });
                if (time) {
                    time = Math.round(moment.duration(time, 'seconds').asHours() * 100) / 100;
                    if (vm.trackersForSave[taskTracker] !== undefined) {
                        let obj = vm.trackersForSave[taskTracker];
                        obj.time = time;
                        Vue.set(vm.trackersForSave, taskTracker, obj);
                    } else {
                        let obj = {
                            time: time,
                            date: '',
                            comment: '',
                            taskTracker: taskTracker
                        };
                        Vue.set(vm.trackersForSave, taskTracker, obj);

                    }
                }
            },
            listenForTaskTrackersChanges(taskTrackers) {
                let vm = this;

                _.each(taskTrackers, function (taskTracker) {

                    if (vm.listenForTaskTrackers[taskTracker] === undefined) {
                        let identity = vm.identity(taskTracker);

                        Vue.ls.on(identity + '.time-intervals', function (timeIntervals) {
                            Vue.set(vm.tempData, taskTracker, timeIntervals);
                            vm.actualizeTable(taskTracker, timeIntervals);
                        });

                        setInterval(function () {
                            let timeIntervals = Vue.ls.get(identity + '.time-intervals');
                            Vue.set(vm.tempData, taskTracker, timeIntervals);
                            vm.actualizeTable(taskTracker, timeIntervals);
                        }, 1000);

                        vm.listenForTaskTrackers[taskTracker] = 1;
                    }
                });
            },
            remove(timer) {
                let vm = this;

                var r = confirm("Are you sure to delete this timer?");
                if (r == true) {
                    vm.loading = true;
                    axios.delete(laroute.route('task.timers.remove', {task: this.task.id, timer: timer.id}))
                        .then(response => {
                            if (response.data.success) {
                                vm.timers = vm.timers.filter(function (timerTemp) {
                                    return timerTemp.id !== timer.id;
                                });
                            }
                            vm.loading = false;
                        })
                        .catch(error => {
                            console.log(error);
                            vm.loading = false;
                        });
                }
            },
            save(trackerForSave) {
                // console.log(trackerForSave);
                let vm = this;
                vm.loading = true;
                axios.post(laroute.route('task.timers', {task: this.task.id}), {
                    work_date: moment(trackerForSave.date).format('DD.MM.YYYY'),
                    description: trackerForSave.comment,
                    duration: trackerForSave.time,
                }).then(response => {

                    vm.timers.push(response.data);

                    if (trackerForSave === vm.manually) {
                        vm.manually = {
                            date: '',
                            comment: '',
                            time: 0
                        }
                    } else {
                        this.$emit('removeTracker', trackerForSave)
                    }


                    vm.loading = false;

                    vm.$notify.success('Success save');
                })
                    .catch(error => {
                        vm.$notify.error('Error trying to save');
                        vm.loading = false;
                        console.log(error);
                    })

            },
            identity(trackerId) {
                return 'tasks.' + this.task.id + '.' + trackerId;
            },
            trans: function (path) {
                return Lang.trans(path);
            },
            loadTimers() {
                let vm = this;
                vm.loading = true;
                axios.get(laroute.route('task.timers', {task: this.task.id}))
                    .then(response => {
                        vm.timers = response.data;
                        vm.loading = false;
                    }).catch(error => {
                    console.log(error);
                })
            }
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/tasks/TaskTimers.vue